import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { ClothingDisposition, ClothingDispositionRequest, ClothingDispositionUnit } from '../../../models/clothing-disposition.model';
import { ClothingDispositionService } from '../../../services/clothing-disposition.service';
import { ASSET } from './asset.constants';
import { CLOTHING_DISPOSITION as C } from './clothing-disposition.constants';
import { assetErrorKey, assetOperationId } from './asset.helpers';

const MONTH_LENGTH = 7;

@Component({selector: 'app-clothing-disposition-modal', templateUrl: './clothing-disposition-modal.component.html',
  styleUrls: ['./asset-form.component.css']})
export class ClothingDispositionModalComponent implements OnInit, OnDestroy {
  unit: ClothingDispositionUnit;
  disposition: ClothingDisposition;
  action: string;
  itemName: string;
  unitNumber: number;
  draft: ClothingDispositionRequest;
  constants = C;
  assetConstants = ASSET;
  errorKey = ASSET.empty;
  payrollMonth = ASSET.empty;
  busy = false;
  confirmed = false;
  showCalculation = false;
  financialAction = false;
  reconciliationAction = false;
  private destroyed = new Subject<void>();

  constructor(public modal: NgbActiveModal, private api: ClothingDispositionService) {}

  ngOnInit(): void {
    this.financialAction = this.action === C.deduction || this.action === C.reapply;
    this.reconciliationAction = this.action === C.reconcileException;
    this.draft = {operationId: assetOperationId(), action: this.action,
      expectedVersion: this.disposition ? this.disposition.version : this.unit.version,
      quoteVersion: this.disposition ? this.disposition.quoteVersion : undefined,
      currency: ASSET.byn, fullDeductionConfirmed: false};
    if (this.reconciliationAction) { this.draft.amountByn = ASSET.zero; }
  }

  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }

  dateChanged(): void {
    this.payrollMonth = this.draft.effectiveDate ? this.draft.effectiveDate.slice(ASSET.zero, MONTH_LENGTH) : ASSET.empty;
  }

  submit(): void {
    if (this.busy || !this.confirmed || this.errorKey === ASSET.deniedKey || this.errorKey === ASSET.conflictKey) { return; }
    if (this.financialAction && (!this.draft.fullDeductionConfirmed || this.draft.amountByn == null
      || this.draft.amountByn !== this.disposition.amountByn || !this.draft.effectiveDate
      || !this.draft.payrollCalculationReference || !this.draft.reason)) { this.errorKey = ASSET.validationKey; return; }
    this.busy = true;
    const request = this.action === C.resume ? this.api.resume(this.disposition.id) : this.api.act(this.unit, this.draft);
    request.takeUntil(this.destroyed).subscribe(result => {
      this.modal.close(result);
    }, error => { this.busy = false; this.errorKey = assetErrorKey(error, true); });
  }

  refresh(): void {
    this.busy = true;
    this.api.unit(this.unit.unitId).takeUntil(this.destroyed).subscribe(result => {
      this.unit = result; this.disposition = result.disposition;
      this.draft.expectedVersion = this.disposition ? this.disposition.version : result.version;
      this.draft.quoteVersion = this.disposition ? this.disposition.quoteVersion : undefined;
      if (this.action !== C.resume) { this.draft.operationId = assetOperationId(); }
      this.confirmed = false;
      this.busy = false; this.errorKey = ASSET.empty;
      const allowed = this.disposition ? this.disposition.allowedActions.indexOf(this.action) >= ASSET.zero
        : this.action === C.retain && result.canRetain || this.action === C.returnAction && result.canReturn;
      if (!allowed) {
        this.errorKey = ASSET.deniedKey;
      }
    }, error => { this.busy = false; this.errorKey = assetErrorKey(error, false); });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/clothing-disposition-modal.component.ts